import React, { useEffect, } from 'react';
import { useParams } from 'react-router-dom';
import { articlesData } from './articlesData';  // import ข้อมูลบทความจากไฟล์
import "./Articles.css";

const Articles = () => {

  const { id } = useParams();
  const article = articlesData.find((article) => article.id === id);

  useEffect(() => {
    // เลื่อนหน้าจอไปที่ Nav โดยใช้ `scrollIntoView`
    const navElement = document.querySelector('.nav');  // เลือก .nav (Nav bar ของคุณ)
    if (navElement) {
      navElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // เลื่อนไปที่ตำแหน่งบนสุดของ Nav
    }
  }, [id]);
  // เมื่อค่า id เปลี่ยนแปลงจะทำการเลื่อนหน้าใหม่

  if (!article) {
    return <p>ไม่พบบทความนี้</p>;
  }

  return (
    <div>
      <h1>{article.title}</h1>
      <div className='article'>
        <div dangerouslySetInnerHTML={{ __html: article.content }} />
      </div>
    </div>
  );
};

export default Articles;
